import React from 'react';

export const LockedCircle = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 242 241" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect x="9.125" y="8.5" width="224" height="224" rx="112" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.1667 120.5C78.0141 120.5 75.4584 123.056 75.4584 126.208V166.167C75.4584 169.319 78.0141 171.875 81.1667 171.875H161.083C164.236 171.875 166.792 169.319 166.792 166.167V126.208C166.792 123.056 164.236 120.5 161.083 120.5H81.1667ZM64.0417 126.208C64.0417 116.75 71.7088 109.083 81.1667 109.083H161.083C170.541 109.083 178.208 116.75 178.208 126.208V166.167C178.208 175.625 170.541 183.292 161.083 183.292H81.1667C71.7088 183.292 64.0417 175.625 64.0417 166.167V126.208Z"
        fill="#DC646A"
        stroke="#DC646A"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.125 69.125C115.069 69.125 109.261 71.5306 104.979 75.8127C100.697 80.0948 98.2917 85.9025 98.2917 91.9583V114.792C98.2917 117.944 95.736 120.5 92.5833 120.5C89.4307 120.5 86.875 117.944 86.875 114.792V91.9583C86.875 82.8746 90.4835 74.163 96.9066 67.7399C103.33 61.3168 112.041 57.7083 121.125 57.7083C130.209 57.7083 138.92 61.3168 145.343 67.7399C151.767 74.163 155.375 82.8746 155.375 91.9583V114.792C155.375 117.944 152.819 120.5 149.667 120.5C146.514 120.5 143.958 117.944 143.958 114.792V91.9583C143.958 85.9025 141.553 80.0948 137.271 75.8127C132.989 71.5306 127.181 69.125 121.125 69.125Z"
        fill="#DC646A"
        stroke="#DC646A"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="9.125" y="8.5" width="224" height="224" rx="112" stroke="#DC646A" strokeWidth="17" />
    </svg>
  );
};

export default LockedCircle;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/LockedCircle.jsx